import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation loginMember($emailOrPhone: String!, $password: String!) {
    loginMember(emailOrPhone: $emailOrPhone, password: $password) {
      user {
        id
        email
      }
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;

export const REGISTER = gql`
  mutation registerMember($input: MemberInput!) {
    registerMember(input: $input) {
      id
      email
      phone
    }
  }
`;

export const LOGOUT = gql`
  mutation logout {
    logout
  }
`;
